import React, { ReactElement } from "react";
import {
  GridColDef,
  GridRenderCellParams,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { format, parseISO } from "date-fns";
import { BankHoliday } from "../../API";
import { Tooltip } from "../../components";

type Actions = {
  showUpdateModal: (data?: any) => void;
  showDeleteModal: (data?: any) => void;
  bankHolidays?: BankHoliday[];
};

type RowAction = {
  label: string;
  icon: ReactElement;
  onClick: (
    params: GridRenderCellParams & {
      bankHolidays?: BankHoliday[];
    }
  ) => void;
};

const renderActionButton = (
  { icon, label, onClick }: RowAction,
  params: GridRenderCellParams,
  bankHolidays?: BankHoliday[]
) => (
  <Tooltip title={label} placement="top">
    <div data-testid={`grid-${label.toLowerCase()}-button`}>
      <GridActionsCellItem
        label={label}
        onClick={() => {
          onClick({
            ...params,
            bankHolidays,
          });
        }}
        icon={icon}
        {...({} as any)}
      />
    </div>
  </Tooltip>
);

export const columns = ({
  showUpdateModal,
  showDeleteModal,
  bankHolidays,
}: Actions): GridColDef<BankHoliday>[] => [
  {
    field: "date",
    headerName: "Date",
    minWidth: 112,
    renderCell: ({ value }) => format(parseISO(value), "dd/MM/yyyy"),
  },
  {
    field: "localName",
    headerName: "Name",
    minWidth: 50,
  },
  {
    field: "countryCode",
    headerName: "Country",
    minWidth: 50,
  },
  {
    field: "counties",
    headerName: "Counties",
    align: "left",
    flex: 1,
    valueGetter: ({ row }) => (row.counties ?? []).join("; "),
  },
  {
    field: "actions",
    headerName: "Actions",
    cellClassName: "actions",
    width: 96,
    sortable: false,
    headerAlign: "left",
    renderCell: (params) => (
      <>
        {renderActionButton(
          {
            label: "Edit",
            icon: <EditIcon />,
            onClick: showUpdateModal,
          },
          params,
          bankHolidays
        )}
        {renderActionButton(
          {
            label: "Delete",
            icon: <DeleteIcon />,
            onClick: showDeleteModal,
          },
          params
        )}
      </>
    ),
  },
];

export const hiddenColumnsMobile: { [key: string]: boolean } = {};
